<template>
  <div class="forget-page">
    <pageHeader />
    <section class="start">
      <div class="right-sec sec min-mobile">
        <div class="content1 auth-center">
          <div class="form-co">
            <div class="info">
              <h4>{{ $t('auth.pleasephone') }}</h4>
              <p class="gray-col font14">
                {{ $t('auth.pleasephonephase') }}
              </p>
            </div>
            <v-form @submit.prevent="ValidForget" v-model="valid" ref="form">
              <div class="main-input-cont mt-1 tel-input-me">
                <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.phone') }}</h6>
                <v-text-field
                  v-model="phone"
                  name="phone"
                  type="number"
                  min="0"
                  :rules="phoneRules"
                  :placeholder="$t('auth.phoneplace')"
                ></v-text-field>
                <div class="drop-countries top-def">
                  <Dropdown
                    v-model="selectedCountry"
                    :options="countries"
                    optionLabel="name"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value" class="flex-group-me">
                        <img
                          :alt="slotProps.value.label"
                          :src="slotProps.value.image"
                          :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.value.key }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                      <div class="flex-group-me">
                        <img
                          :alt="slotProps.option.label"
                          :src="slotProps.option.image"
                          :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.option.key }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
              <button
                type="submit"
                :disabled="disabled"
                class="main-btn mt-4 up w-100 xl"
              >
                <div v-if="!disabled">{{ $t('auth.confirm') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('auth.confirming') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
      <welcomeView />
    </section>
  </div>
</template>

<script setup>
import pageHeader from "../components/pageHeader.vue";
import welcomeView from "../components/home/welcomeView.vue";
import Dropdown from "primevue/dropdown";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
const { t } = useI18n();

// reactive state

const selectedCountry = ref({
  key: "+966",
  code: "SA",
  image:
    "http://backend.saqf-sa.com/public/storage/images/countries/1704282290_8447.png",
});
const countries = ref([]);
const valid = ref(false);
const disabled = ref(false);
const form = ref(null);

const phone = ref("");
const phoneRules = ref([
  (value) => {
    if (value) return true;

    return t(`auth.phoneValid`);
  },
  (value) => {
    if (value.length >= 9) return true;

    return t(`auth.phoneValidnumber`);
  },
]);

// functions
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
    selectedCountry.value = response.data.data?.find(
      (country) => country.key == "+966"
    ) || response.data.data[0];
  });
}
function sendForm() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  // fd.append("type", SendedVal.value);
  fd.append("country_code", selectedCountry.value.key);

  axios.post("/manager/forget-password-send-code", fd).then((response) => {
    if (response.data.key == "success") {
      localStorage.setItem("phone", phone.value);
      localStorage.setItem("country_code", selectedCountry.value.key);
      toast.add({
        severity: "success",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      router.push("/forgetPassCheck");
    } else {
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
    }
    disabled.value = false;
  });
}
function ValidForget() {
  if (valid.value) {
    sendForm();
  }
}

onMounted(() => {
  getCountries();
});
</script>
